export type UsageResourceType = 'COUNT' | 'CREDIT';

export interface ApiGetMyUsageListRequest {
    page: number;
    limit: number;
    task_types?: string[];
    start_time?: number;
    end_time?: number;
}

export interface MyUsageRecord {
    pk: string;
    task_name?: string;
    task_id: string;
    task_type: string;
    resource_type: UsageResourceType;
    usage_value: number;
    created_at: number;
}

/**
 * 与后端 CommonPage<T> 序列化形态保持一致：
 *   { page, limit, totalPage, total, list }
 * 其中 page/limit/totalPage 为驼峰，list 元素字段为下划线（DTO 上 @JsonProperty 控制）。
 */
export interface ApiGetMyUsageListResponse {
    list: MyUsageRecord[];
    total: number;
    page: number;
    limit: number;
    totalPage: number;
}

export const GetMyUsageList = Symbol('GetMyUsageList');

export interface GetMyUsageList {
    getMyUsageList(data: ApiGetMyUsageListRequest): Promise<ApiGetMyUsageListResponse>;
}
